module.exports = __webpack_public_path__ + "static/media/arrowNext.d52f4cba.svg";